module.exports = __webpack_public_path__ + "img/new-analyse.2be2ee39.svg";